import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.20_@babel+core@7.25.2_@opentelemetry+api@1.9.0_@playwright+test@1.46.1_babel-plugin_bb6q7lkkvwf4lil4btetidfyfy/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DownVoteButton"] */ "/vercel/path0/packages/plugins/roadmap/src/components/downvote-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IssueDetailDialog"] */ "/vercel/path0/packages/plugins/roadmap/src/components/issue-detail-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IssueSubmissionDialog"] */ "/vercel/path0/packages/plugins/roadmap/src/components/issue-submission-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IssuesKanban"] */ "/vercel/path0/packages/plugins/roadmap/src/components/issues-kanban.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IssuesFilters"] */ "/vercel/path0/packages/plugins/roadmap/src/components/issues-list-filters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpVoteButton"] */ "/vercel/path0/packages/plugins/roadmap/src/components/upvote-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/makerkit/marketing/newsletter-signup-container.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/src/makerkit/marketing/newsletter-signup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/vercel/path0/packages/ui/src/shadcn/tabs.tsx");
